import React, { useState } from 'react';
import { GolfCourseProps, GolfHoleProps, GolfScorecardProps } from '../../../store/types/sr_svc';
import { FlatList, View } from 'react-native';
import { Text } from '../../../globalComponents/NativeOverrides';
import Colors from '../../../constants/Colorsv2';

type GolfRoundScoreCardProps = {
    golf_course:GolfCourseProps,
    golf_scorecards:GolfScorecardProps[],
    width:number
}

const score_colors= [ 
    {score:'albatross', color:Colors.highlights.highlight100Faded },
    {score:'eagle', color:Colors.highlights.highlight200Faded },
    {score:'birdie', color:Colors.highlights.highlight400Faded },
    {score:'par', color:'transparent' },
    {score:'bogey', color:Colors.highlights.highlight300Faded },
    {score:'other', color:Colors.highlights.highlight500Faded }
]

const GolfRoundScoreCard = ({ golf_course, golf_scorecards, width }:GolfRoundScoreCardProps) => {
    const [ scorecard_width, setScorecardWidth ] = useState(0);

    const getScoreColor = (hole:GolfHoleProps, score:GolfScorecardProps) => {
        if(score.strokes == 0){ return 'transparent' }
        let score_diff = score.strokes - hole.par
        let score_name = 'par'
        switch(score_diff){
            case -3: score_name = 'albatross'; break
            case -2: score_name = 'eagle'; break
            case -1: score_name = 'birdie'; break
            case 0: score_name = 'par'; break
            case 1: score_name = 'bogey'; break
            case 2: score_name = 'other'; break
            default: score_name = 'other'; break;
        }
        let score_color = score_colors.find(sc => sc.score == score_name)
        if(!score_color){ return 'transparent' }
        return score_color.color
    }


    return (
        <View>
            <View style={{ flexDirection:'row', overflow:'scroll', padding:10 }}>
                <View style={{ paddingRight:10 }}>
                    <View style={{ borderBottomWidth:1, borderBottomColor:Colors.shades.shade100 }}>
                        <Text style={{ padding:10 }} size={14} color={Colors.brand.midnight} weight='regular'>HOLE</Text>
                    </View>
                    <View style={{ borderBottomWidth:1, borderBottomColor:Colors.shades.shade100 }}>
                        <Text style={{ padding:10 }} size={14} color={Colors.brand.midnight} weight='regular'>Par</Text>
                    </View>
                    <View style={{ borderBottomWidth:1, borderBottomColor:Colors.shades.shade100 }}>
                        <Text style={{ padding:10 }} size={14} color={Colors.brand.midnight} weight='bold'>Score</Text>
                    </View>
                </View>
                {golf_course.holes.map(h => {
                    let score = golf_scorecards.find(sc => sc.hole_number == h.number)
                    return (
                        <View style={{ width:width / 7 }}>
                            <View style={{ borderBottomWidth:1, borderBottomColor:Colors.shades.shade100 }}>
                                <Text textAlign='center' style={{ padding:10 }} size={14} color={Colors.brand.midnight} weight='regular'>{h.number}</Text>
                            </View>
                            <View style={{ borderBottomWidth:1, borderBottomColor:Colors.shades.shade100 }}>
                                <Text textAlign='center' style={{ padding:10 }} size={14} color={Colors.brand.midnight} weight='regular'>{h.par}</Text>
                            </View>
                            {score?
                            <View style={{ borderBottomWidth:1, borderBottomColor:Colors.shades.shade100, borderRadius:4, backgroundColor: getScoreColor(h, score) }}>
                                <Text textAlign='center' style={{ padding:10 }} size={14} color={Colors.brand.midnight} weight='bold'>{score.strokes > 0?score.strokes:'-'}</Text>
                            </View>
                            :<></>}
                        </View>
                    )
                })}
            </View>
            <View nativeID='score_legend' style={{ flexDirection:'row', alignItems:'center', margin:10 }}>
                {score_colors.filter(sc => sc.score != 'par').map(c => {
                    return (
                        <View style={{ flexDirection:'row', alignItems:'center', marginRight:10 }}>
                            <View style={{ marginRight:3, height:10, width:10, borderRadius:2, backgroundColor:c.color }} />
                            <Text size={10} color={Colors.brand.slate} weight='regular'>{c.score}</Text>
                        </View>
                    )
                })}
            </View>
        </View>
    )
}

export default GolfRoundScoreCard